import React from 'react'

function AgenziaInfo({ agenziaData }) {
  const d = agenziaData ?? {};
  return (
    <div className='container'>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Ragione sociale</b></span>
               <span className='d-block'>{d.denominazione || 'N/A'}</span>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Indirizzo</b></span>
               <span className='d-block'>{d.indirizzo || 'N/A'}</span> 
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>CAP</b></span>
               <span className='d-block'>{d.cap || 'N/A'}</span> 
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Città</b></span>
               <span className='d-block'>{d.citta || 'N/A'}</span> 
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Provincia</b></span>
               <span className='d-block'>{d.provincia || 'N/A'}</span> 
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Partita iva</b></span>
               <span className='d-block'>{d.piva || 'N/A'}</span> 
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Referente</b></span>
               <span className='d-block'>{d.referente || 'N/A'}</span> 
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Email</b></span>
               <span className='d-block'>{d.email || 'N/A'}</span> 
            </div>
        </div>
        <div className='row'>
            <div className='col-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>Note</b></span>
               <span className='d-block'>{d.note || 'N/A'}</span> 
            </div>
        </div>
        {(d.spedizione_nominativo || d.spedizione_indirizzo || d.spedizione_cap || d.spedizione_citta || d.spedizione_provincia) && (
            <>
                <div className='row mt-3'>
                    <div className='col-12'>
                        <span className='fs-5 d-block'><i>Dati spedizione attestati</i></span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-12 col-md-6 my-2'>
                        <span className='small text-muted d-block mb-1'><b>Nominativo destinatario</b></span>
                        <span className='d-block'>{d.spedizione_nominativo || d.denominazione || 'N/A'}</span>
                    </div>
                    <div className='col-sm-12 col-md-6 my-2'>
                        <span className='small text-muted d-block mb-1'><b>Indirizzo</b></span>
                        <span className='d-block'>{d.spedizione_indirizzo || 'N/A'}</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-12 col-md-4 my-2'>
                        <span className='small text-muted d-block mb-1'><b>CAP</b></span>
                        <span className='d-block'>{d.spedizione_cap || 'N/A'}</span>
                    </div>
                    <div className='col-sm-12 col-md-4 my-2'>
                        <span className='small text-muted d-block mb-1'><b>Città</b></span>
                        <span className='d-block'>{d.spedizione_citta || 'N/A'}</span>
                    </div>
                    <div className='col-sm-12 col-md-4 my-2'>
                        <span className='small text-muted d-block mb-1'><b>Provincia</b></span>
                        <span className='d-block'>{d.spedizione_provincia || 'N/A'}</span>
                    </div>
                </div>
            </>
        )}
    </div>
  )
}

export default AgenziaInfo;